import { render } from "./HomeCareReassign.vue?vue&type=template&id=8b405b6a&ts=true"
import script from "./HomeCareReassign.ts?vue&type=script&lang=ts&external"
export * from "./HomeCareReassign.ts?vue&type=script&lang=ts&external"

import "./HomeCareReassign.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__